module.exports = "/timeclock/components/noteHistoryLogComponent-ed1fcf.html";